export const linkBuilder = (
    resource = {},
    owner = null,
    refererPath = null
) => {
    const {
        type: resourceType = "",
        id: resourceId = "",
        owner: resourceOwner = null,
    } = resource;
    const external = resourceOwner && owner && resourceOwner !== owner;

    const routes = {
        activity: `/portfolio/activities/${resourceId}`,
        resource: `/portfolio/resources/${resourceId}`,
        pdp: external
            ? `/portfolio/pdps/${resourceId}?rp=${refererPath}`
            : `/portfolio/pdps/${resourceId}`,
        signOff: external
            ? `/rms/appraisals/${resourceId}/${resourceOwner}?rp=${refererPath}`
            : `/rms/appraisals/${resourceId}`,
        appraisal: external
            ? `/rms/appraisals/${resourceId}/${resourceOwner}?rp=${refererPath}`
            : `/rms/appraisals/${resourceId}`,
        appraisals: `/rms/appraisals`,
        terms: `/terms/${resourceId}`,
        MSFSurvey: external
            ? `/msf/surveys/${resourceId}/${resourceOwner}?rp=${refererPath}`
            : `/msf/surveys/${resourceId}`,
        MSFQuestionnaire: `/msf/questionnaires/${resourceId}`,
        default: "/tasks/",
    };

    return routes[resourceType] || routes.default;
};
